import { AppConfigStore } from "./appConfigStore";
import configClient from "src/api/clients/config";

const makeGetConfigRequest = (): Promise<AppConfigStore> => {
  return configClient.get("config.json");
};

export default makeGetConfigRequest;
